import a from "axios";
var o = "https://tea-shop-base-biz".replace(/\/+$/, ""), i = class {
  constructor(r, s = o, t = a) {
    if (this.basePath = s, this.axios = t, r) {
      var e;
      this.configuration = r, this.basePath = (e = r.basePath) !== null && e !== void 0 ? e : s;
    }
  }
}, l = class extends Error {
  constructor(r, s) {
    super(s), this.field = r, this.name = "RequiredError";
  }
}, p = {};
export {
  o as BASE_PATH,
  i as BaseAPI,
  l as RequiredError,
  p as operationServerMap
};

//# sourceMappingURL=base.js.map